import { Injectable } from '@angular/core';
import { State, Selector, StateContext, Action } from '@ngxs/store';
import _, { NumericDictionary } from 'lodash';
import { SamwinUserShortInfoRemoteDto } from 'src/generated/signalR/samwin-user-short-info-remote-dto';
import { UserConfigurationChanged } from './samwin-user-configuration.action';

export interface SamwinUserConfigurationStateModel {
   users: NumericDictionary<SamwinUserShortInfoRemoteDto>;
}

@State<SamwinUserConfigurationStateModel>({
   name: 'samwinUserConfiguration',
   defaults: {
      users: [],
   },
})
@Injectable()
export class SamwinUserConfigurationState {
   constructor() {}

   @Selector([SamwinUserConfigurationState])
   public static getUserConfigurationFn(state: SamwinUserConfigurationStateModel): (userId: number) => SamwinUserShortInfoRemoteDto {
      return (userId: number) => {
         return state.users[userId];
      };
   }

   @Action(UserConfigurationChanged)
   public userConfigurationChanged(ctx: StateContext<SamwinUserConfigurationStateModel>, action: UserConfigurationChanged) {
      ctx.patchState({
         users: _.keyBy(action.users, (u) => u.id),
      });
   }
}
